import React from 'react';
import Paper from 'apollo-react/components/Paper';
import MenuItem from 'apollo-react/components/MenuItem';
import SelectButton from 'apollo-react/components/SelectButton';
import DateRangePicker from 'apollo-react/components/DateRangePicker';
import Typography from '../StyledTypography';
import {
  DASHBOARD_DATE_PRESET_OPTIONS,
  getDashboardDatePresetLabel,
} from '../../../utils/dashboardDateRangeUtils';
import styles from './DashboardDateRangeFilter.module.css';

/**
 * @param {{
 *   value: { preset: string, customRange: any },
 *   onChange: (next: { preset: string, customRange: any }) => void,
 * }} props
 */
export function DashboardDateRangeFilter({ value, onChange }) {
  const handlePresetChange = (preset) => {
    onChange({
      preset,
      customRange: preset === 'custom' ? value.customRange : null,
    });
  };

  const handleCustomRangeChange = (customRange) => {
    onChange({
      preset: 'custom',
      customRange,
    });
  };

  return (
    <Paper className={styles.filterBar}>
      <Typography variant="bodySmall" className={styles.filterLabel}>
        Filter with date
      </Typography>
      <SelectButton
        value={value.preset}
        displayText={getDashboardDatePresetLabel(value.preset)}
        onChange={handlePresetChange}
        placeholder="Time period"
        size="small"
        noDeselect
        className={styles.presetSelect}
      >
        {DASHBOARD_DATE_PRESET_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </SelectButton>
      {value.preset === 'custom' ? (
        <div className={styles.customRange}>
          <DateRangePicker
            value={value.customRange}
            onChange={handleCustomRangeChange}
            startLabel=""
            endLabel=""
            startProps={{ placeholder: 'From' }}
            endProps={{ placeholder: 'To' }}
            placeholder="mm/dd/yyyy"
            className={styles.dateRangePicker}
            size="small"
            fullWidth
          />
        </div>
      ) : null}
    </Paper>
  );
}

export default DashboardDateRangeFilter;
